import React from 'react'
import PropTypes from 'prop-types'

import { ReorderBanner } from '../ReorderBanner/ReorderBanner'
import { PopularItems } from '../PopularItems/PopularItems'
import {useFlag} from '../FeatureFlag/use-flag'
import {useAuth} from '../AuthProvider/AuthProvider'

const ReordersOrPopularItemsBanner = ({ hasReorders }) => {
  const reorderEnabled = useFlag('oo-v3-reorder')
  const { authenticated } = useAuth()
  const canReorder = reorderEnabled && hasReorders && authenticated

  if (canReorder) {
    return <ReorderBanner />
  }

  return <PopularItems />
}

ReordersOrPopularItemsBanner.propTypes = {
  hasReorders: PropTypes.bool.isRequired
}

ReordersOrPopularItemsBanner.defaultProps = {
  hasReorders: false
}

export { ReordersOrPopularItemsBanner }
